import { render, staticRenderFns } from "./HeraAI.vue?vue&type=template&id=639c56ba&scoped=true&"
import script from "./HeraAI.vue?vue&type=script&lang=js&"
export * from "./HeraAI.vue?vue&type=script&lang=js&"
import style0 from "./HeraAI.vue?vue&type=style&index=0&id=639c56ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c56ba",
  null
  
)

export default component.exports